<template>
  <v-application v-if="access.inv_purchase_orders">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="purchase"
          to="/inventory/purchase"
          v-bind:num-pages="purchases_total"
          v-model="currentPage"
          v-bind:headers="headers"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_purchase'"
          v-bind:data="purchases"
          view
          no-delete
          showSearch
          InventoryPurchase
          v-bind:search_text="search_text"
          v-bind:getData="update_purchases"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              outlined
              dense
              v-model="status"
              label="Status"
              v-bind:items="statusses"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              outlined
              dense
              v-model="type"
              label="Type"
              v-bind:items="types"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              outlined
              dense
              v-model="supplier"
              label="Supplier"
              v-bind:items="all_suppliers_"
              hide-details
              item-text="supplier_name"
              class="mx-1"
            />
            <v-combobox
              outlined
              dense
              v-model="store"
              label="Store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              item-text="name"
              hide-details
              label="Employe"
              v-model="employee"
              v-bind:items="all_employees_"
              prepend-inner-icon="mdi-account"
              clear-icon="mx-1"
              outlined
              dense
            />
            <v-btn icon @click="download_dialog = true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
        </v-crud-card>
        <v-dialog v-model="download_dialog" max-width="800px" persistent>
          <v-card>
            <v-card-title>Download purchases</v-card-title>
            <v-row no-gutters class="mx-4">
              <v-col>
                <data-picker
                  v-model="download_start"
                  class="pa-2"
                  style="width: 100%"
                  placeholder="Start date"
                  format="DD-MM-YYYY HH:mm"
                  :showSecond="true"
                  :show-hour="true"
                  :show-minute="true"
                />
              </v-col>
              <v-col>
                <data-picker
                  v-model="download_end"
                  class="pa-2"
                  style="width: 100%"
                  placeholder="End date"
                  format="DD-MM-YYYY HH:mm"
                  :showSecond="false"
                />
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click="downloadCancel">
                Cancel
              </v-btn>

              <v-btn
                text
                color="primary"
                @click="downloadPurchases"
                :disabled="download_start === null || download_end === null"
              >
              Save Excel
                <!-- <export-excel
                  :data="downPurchases"
                  :name="excel_name"
                  v-html="'Save Excel'"
                /> -->
                <!--:fields="my_Fields"-->
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Purchases from "../../mixins/inventory/purchase";
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
import Emplooyes from "../../mixins/employees/workgroup";
import DataPicker from "vue2-datepicker";
import fileSaver from "file-saver";
import xlsx from "xlsx";

const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  name: "InventoryPurchase",
  mixins: [Purchases, Services, AllSuppliers, Emplooyes],
  components: {
    DataPicker,
  },
  data: () => ({
    page: 1,
    employee: null,
    store: null,
    // headers: [
    //   { text: "Purchase order", value: "p_order" },
    //   { text: "Date", value: "purchase_order_date" },
    //   { text: "Supplier", value: "supplier_name" },
    //   { text: "Store", value: "service_name" },
    //   { text: "Status", value: "status" },
    //   { text: "Received", value: "received" },
    //   { text: "Expected on", value: "expected_on" },
    //   { text: "Total", value: "total", align: "right" },
    // ],
    data: [],
    search_text: false,
    search: "",
    download_dialog: false,
    download_start: null,
    download_end: null,
    downPurchases: [],
    excel_name: "Purchases",
  }),
  methods: {
    changePagination(page) {
      this.$store.commit("purchaseOrder/updatePagination", page);
      this.update_purchases(this.params);
    },
    defaultvalue() {
      this.employee = this.all_employees_[0].name;
    },
    async downloadPurchases() {
      this.data_loading = true;
      const downPurchases = this.$communicator.then(
        this,
        await this.$communicator("purchases", {
          arguments: [99999999, 1],
          params: {
            min: new Date(this.download_start).getTime(),
            max: new Date(this.download_end).getTime(), // 23:59:59
            service: this.store._id,
            supplier_id: this.supplier._id,
            status: this.status.value,
            search: this.search,
            type: this.type.value,
            employee_id: this.employee._id,
          },
        })
      );

      if (downPurchases && Array.isArray(downPurchases.data)) {
        const data = []
        for (const purchase of downPurchases.data) {
          for (const item of purchase.items) {
            data.push({
              "Document": purchase.p_order,
              Type: purchase.type.toUpperCase(),
              Store: purchase.service_name,
              SKU: item.sku,
              Date: this.date_ddmmyy_hhmm(purchase.purchase_order_date),
              Supplier: purchase.supplier_name,
              Inn: purchase.supplier_inn ? purchase.supplier_inn : '-',
              [`${this.$t("supplier_contract")}`]: purchase.supplier_contract ? purchase.supplier_contract : '-',
              "Item name": item.product_name,
              "Category name": item.category_name,
              Price: item.purchase_cost,
              Quantity: item.received,
              Total: item.amount,
              Employee: purchase.ordered_by_name,
              Status: purchase.status.toUpperCase(),
              Comment: purchase.notes,
            })
          }
        }

        this.downPurchases = data;
        this.data_loading = false;

        const ws = xlsx.utils.json_to_sheet(data);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
        const excel_data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        fileSaver.saveAs(excel_data, "PurchaseReports.xlsx");
      }
    },
    downloadCancel() {
      this.download_dialog = false;
      this.download_start = null;
      this.download_end = null;
      this.downPurchases = [];
    },
  },
  beforeMount() {
    // this.options = this.$store.state.options;
    // this.employees = [{ name: this.$t("all_employees"), _id: "" }];
    this.access = this.$store.state.access;
    this.status = this.$store.state.status1;
    if (this.status && !this.status.name) {
      this.status.name = this.$t("all");
    }
    this.type = this.$store.state.type_pur;
    if (this.type && !this.type.name) {
      this.type.name = this.$t("all");
    }
    this.supplier = this.$store.state.supplier1;
    if (this.supplier && !this.supplier.supplier_name) {
      this.supplier.supplier_name = this.$t("all_suppliers");
    }
    this.store = this.$store.state.items_current_service;
  },
  // updated() {
  //   this.first_time = true;
  //   if (this.value != this.pagination_value) {
  //     this.pagination_value = this.value;
  //   }
  // },
  computed: {
    currentPage: {
      get() {
        return this.$store.state.purchaseOrder.page;
      },
      set(val) {
        this.$store.commit("purchaseOrder/updatePagination", val);
      },
    },
    headers() {
      let headers = [
        { text: this.$t("purchase_order"), value: "p_order", available: true },
        {
          text: this.$t("date"),
          value: "purchase_order_date",
          available: true,
        },
        {
          text: this.$t("employee_name"),
          value: "ordered_by_name",
          available: true,
        },
        { text: this.$t("supplier"), value: "supplier_name", available: true },
        { text: this.$t("store"), value: "service_name", available: true },
        { text: this.$t("status"), value: "status", available: true },
        { text: this.$t("received"), value: "received", available: true },
        { text: this.$t("expected_on"), value: "expected_on", available: true },
        { text: this.$t("type"), value: "type", available: true },
        {
          text: this.$t("total"),
          value: "total",
          align: "right",
          available: true,
        },
      ];
      // if (this.user_access && this.user_access.inv_purchase_orders_cost) {
      //   headers.push({
      //     text: this.$t('total'),
      //     value: 'total',
      //     align: 'right',
      //   })
      // }
      return headers;
    },
    my_Fields() {
      const down_headers = {
        "Purchase order": "p_order",
        Date: "purchase_order_date",
        "Employee name": "ordered_by_name",
        "Supplier name": "supplier_name",
        Store: "service_name",
        Status: "status",
        Received: "received",
        "Expected on": "expected_on",
        Type: "type",
        Total: "total",
      };
      return down_headers;
    },
  },
  created() {
    this.defaultvalue();
  },
  mounted() {
    // for (const index in this.headers) {
    //   this.headers[index]["sortable"] = false;
    // }
    this.defaultvalue();
  },
  watch: {
    employee: {
      deep: true,
      handler() {
        this.update_purchases();
      },
    },
    store: {
      deep: true,
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_purchases();
      },
    },
    supplier: {
      deep: true,
      handler() {
        this.$store.commit("setSupplier", this.supplier);
        this.update_purchases();
      },
    },
    type: {
      deep: true,
      handler() {
        this.$store.commit("setType", this.type);
        this.update_purchases();
      },
    },
    status: {
      deep: true,
      handler() {
        this.$store.commit("setStatus", this.status);
        this.update_purchases();
      },
    },
    download_end() {
      const endDate = new Date(this.download_end)
      if(endDate.getHours() !== 0){
        return
      }
      endDate.setHours(23)
      endDate.setMinutes(59)
      endDate.setSeconds(59)
      endDate.setMilliseconds(999)

      this.download_end = endDate
    },
  },
};
</script>
<style></style>
